<ng-container *ngIf="downloadProgramGuideContent && programGuideUrl">
  <div *ngIf="!isButton">
    <a *ngIf="programGuideUrl" [href]="programGuideUrl" target="_blank">
      <ng-container *ngIf="isExpanded && downloadProgramGuideContent.expandedBanner; else defaultBanner">
        <img class="d-none d-lg-block banner-expanded" [src]="downloadProgramGuideContent.expandedBanner" />
        <img
          class="d-none d-sm-block d-lg-none banner-expanded"
          [src]="downloadProgramGuideContent.tabletExpandedBanner"
        />
        <img class="d-sm-none banner-expanded" [src]="downloadProgramGuideContent.mobileExpandedBanner" />
      </ng-container>
      <ng-template #defaultBanner>
        <img class="d-none d-lg-block banner" [src]="downloadProgramGuideContent.banner" />
        <img class="d-none d-sm-block d-lg-none banner" [src]="downloadProgramGuideContent.tabletBanner" />
        <img class="d-sm-none banner" [src]="downloadProgramGuideContent.mobileBanner" />
      </ng-template>
    </a>
  </div>
  <div *ngIf="isButton">
    <a
      *ngIf="programGuideUrl"
      [href]="programGuideUrl"
      target="_blank"
      class="btn btn-outline-purple d-flex align-items-center justify-content-center"
    >
      {{ 'Review' | translate }} <fa-icon class="ms-2" [icon]="['far', 'chevron-right']"></fa-icon>
    </a>
  </div>
</ng-container>
